// Generic imports
import React from "react"
import Select from "./select"
import { kotaProvinsi } from "data/KotaProvinsi"

export default function SelectKota({ defaultChecked, ...props }) {
  return (
    <Select {...props}>
      {defaultChecked ? (
        <></>
      ) : (
        <option disabled selected value>
          {" "}
          -- select an option --{" "}
        </option>
      )}
      {kotaProvinsi.map(({ name, value }, index) => (
        <option value={value} key={index} selected={defaultChecked === value}>
          {name}
        </option>
      ))}
    </Select>
  )
}
